import React from 'react'

import { withContext, WithContextProps } from 'admin/components/common/withContext'

/**
 * Text helper component to output price/currency-formatted text, alternatively rounded
 */
const Price: React.FunctionComponent<PriceProps & WithContextProps> = props => {
  const {children, rounded, decimals, wrap, locale, ...otherProps} = props
  if (rounded) {
    return React.createElement(wrap, otherProps, locale.formatRoundedPrice(children, decimals))
  } 
    return React.createElement(wrap, otherProps, locale.formatPrice(children, decimals))
  
}

Price.defaultProps = {
  rounded: false,
  wrap: 'span',
}

type PriceProps = {
  children?: React.ReactText
  rounded?: boolean,
  decimals?: number,
  wrap?: string,
}

export default withContext(Price)
